import { Type, type Static } from '@sinclair/typebox';
import { reactionSchema } from '../../shared/reaction/reaction.schema';
import { ListResponseSchema } from '../../shared/utils/list-response.schema';

export const AddMessageReactionResponseSchema = Type.Object({
  object: Type.Literal('MessageReactionAdded'),
});

export const RemoveMessageReactionResponseSchema = Type.Object({
  object: Type.Literal('MessageReactionRemoved'),
});

export const GetMessageReactionsListResponseSchema = ListResponseSchema(reactionSchema);

export type AddMessageReactionResponse = Static<typeof AddMessageReactionResponseSchema>;
export type RemoveMessageReactionResponse = Static<typeof RemoveMessageReactionResponseSchema>;
export type GetMessageReactionsListResponse = Static<typeof GetMessageReactionsListResponseSchema>;
